import { CASES_SECTION } from './sections/cases';
import { COLLEAGUES_SECTION } from './sections/colleagues';
import { CONTACTS_SECTION } from './sections/contacts';
import { INVOICE_CREATION_SECTION } from './sections/invoiceCreation';
import { INVOICE_DATES_SECTION } from './sections/invoiceDates';
import { INVOICE_REVIEW_SECTION } from './sections/invoiceReview';
import { TIMECARDS_SECTION } from './sections/timecards';
import type { SettingSectionLayout } from './settingLayout';

/** The setting sections in page order, above the configuration blocks. */
export const SETTING_SECTIONS: SettingSectionLayout[] = [
    CONTACTS_SECTION,
    CASES_SECTION,
    TIMECARDS_SECTION,
    INVOICE_CREATION_SECTION,
    INVOICE_REVIEW_SECTION,
    INVOICE_DATES_SECTION,
    COLLEAGUES_SECTION,
];
